import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "../src/Store/Store";

// Bileşenler
import Form from "./components/Form";
import Navbar from "./components/Navbar";

// Sayfalar
import Auth from "./pages/Auth";
import Details from "./pages/Details";
import List from "./pages/List";
import PageNotFound from "./pages/PageNotFound";
import Signup from "./pages/Signup";
import UserList from "./pages/UserList";
import ResetPassword from "./pages/ResetPassword";
import Guard from "./guard/Guard";
import Dashboard from "./pages/Dashboard";
import LeaveCalendar from "./pages/LeaveCalendar";
import CreateLeavePage from "./pages/CreateLeavePage";
import PasswordOperationsPage from "./pages/PasswordOperationsPage";
import MonthlyReportPage from "./pages/MonthyReport";
import CreateExpensePage from "./pages/CreateExpensePage";
import ExpenseList from "./pages/ExpenseList";
import Settings from "./pages/Settings";
import TravelAllowanceListPage from "./pages/TravelAllowanceListPage";
import CreateTravelAllowancePage from "./pages/CreateTravelAllowancePage";
import TravelAllowanceDetailsPage from "./pages/TravelAllowanceDetailsPage";

// Token kontrol bileşeni
function AuthRedirectGuard() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      localStorage.removeItem("persist:root");
      navigate("/login");
    }
  }, [navigate]);

  return null;
}

function App() {
  const token = useSelector((state) => state.auth.token);
  const [contacts, setContacts] = useState([]);

  return (
    <PersistGate persistor={persistor}>
      <div className="App pt-16">
        <BrowserRouter>
          <AuthRedirectGuard />
          <Navbar />
          <Routes>
            {!token && (
              <>
                <Route path="/" element={<Navigate to="/auth" replace />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/login" element={<Auth />} />
              </>
            )}
            <Route path="/reset-password" element={<ResetPassword />} />
            {token && (
              <>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route
                  path="/dashboard"
                  element={
                    <Guard permissions={["anyallow"]}>
                      <Dashboard />
                    </Guard>
                  }
                />
                <Route
                  path="/izinler"
                  element={
                    <Guard permissions={["anyallow"]}>
                      <List contacts={contacts} />
                    </Guard>
                  }
                />
                <Route
                  path="/annual-leave-form"
                  element={
                    <Guard permissions={["anyallow"]}>
                      <Form addContact={setContacts} contacts={contacts} />
                    </Guard>
                  }
                />
                <Route
                  path="/takvim"
                  element={
                    <Guard permissions={["anyallow"]}>
                      <LeaveCalendar />
                    </Guard>
                  }
                />
                <Route
                  path="/user"
                  element={
                    <Guard permissions={["admin", "superAdmin"]}>
                      <UserList />
                    </Guard>
                  }
                />
                
                <Route
                  path="/signup"
                  element={
                    <Guard permissions={["admin", "superAdmin"]}>
                      <Signup />
                    </Guard>
                  }
                />
                <Route
                  path="/detaylar/:id"
                  element={
                    <Guard permissions={["anyallow"]}>
                      <Details />
                    </Guard>
                  }
                />
                {/* Yeni eklenen sayfalar */}
                <Route
                  path="/yeni-izin"
                  element={
                    <Guard permissions={["anyallow"]}>
                      <CreateLeavePage />
                    </Guard>
                  }
                />
                <Route
                  path="/yeni-masraf"
                  element={
                    <Guard permissions={["anyallow"]}>
                      <CreateExpensePage />
                    </Guard>
                  }
                />
                <Route
                  path="/masraflar"
                  element={
                    <Guard permissions={["anyallow"]}>
                      <ExpenseList />
                    </Guard>
                  }
                />
                <Route
                  path="/sifre-islemleri"
                  element={
                    <Guard permissions={["admin"]}>
                      <PasswordOperationsPage />
                    </Guard>
                  }
                />
                 <Route
                  path="/aylik-rapor"
                  element={
                    <Guard permissions={["admin"]}>
                      <MonthlyReportPage />
                    </Guard>
                  }
                />
                <Route
                  path="/ayarlar"
                  element={
                    <Guard permissions={["admin"]}>
                      <Settings />
                    </Guard>
                  }
                />
                <Route
                  path="/harcirahlar"
                  element={
                    <Guard permissions={["anyallow"]}>
                      <TravelAllowanceListPage />
                    </Guard>
                  }
                />
                <Route
                  path="/yeni-harcirah"
                  element={
                    <Guard permissions={["admin"]}>
                      <CreateTravelAllowancePage />
                    </Guard>
                  }
                />
                <Route
                  path="/harcirah-detay/:id"
                  element={
                    <Guard permissions={["anyallow"]}>
                      <TravelAllowanceDetailsPage />
                    </Guard>
                  }
                />
              </>
            )}
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </BrowserRouter>
        <ToastContainer />
      </div>
    </PersistGate>
  );
}

export default App;